// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_oIELK","count":"count_E1yW6"};